import { render, staticRenderFns } from "./ZBadge.vue?vue&type=template&id=a98f63d2&"
import script from "./ZBadge.vue?vue&type=script&lang=ts&"
export * from "./ZBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports